import { Fn }			from "ts-base/fn";
import { Comparator }	from "ts-base/comparator";

export type Equal<T> = (a:T, b:T) => boolean;

export namespace Equal {
	export const builtin	= <T>(a:T, b:T):boolean => a === b;

	export const builtinOf	= <T>():Equal<T>	=> builtin;

	export const builtinBy	= <S, T>(func:Fn<S, T>):Equal<S> =>
		contraMap(builtin)(func);

	export const not	= <T>(self:Equal<T>):Equal<T>	=>
		(a, b) => !self(a, b);

	export const and	= <T>(first:Equal<T>, second:Equal<T>):Equal<T>	=>
		(a, b) => first(a, b) && second(a, b);

	export const or	= <T>(first:Equal<T>, second:Equal<T>):Equal<T>	=>
		(a, b) => first(a, b) || second(a, b);

	export const fromComparator	= <T>(it:Comparator<T>):Equal<T>	=>
		(a, b) => it(a, b) === 0;

	export const contraMap	= <T>(base:Equal<T>) => <S>(func:Fn<S, T>):Equal<S> =>
		(a:S, b:S) => base(func(a), func(b));
}
